export default "__VITE_ASSET__CqKJEWiD__"